import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  full?: boolean;
}

const COLORS: Record<Variant, { bg: string; fg: string; border: string }> = {
  primary: { bg: 'var(--azure)', fg: '#fff', border: 'var(--azure)' },
  secondary: { bg: 'var(--surface)', fg: 'var(--navy)', border: 'var(--line)' },
  danger: { bg: 'var(--surface)', fg: 'var(--danger)', border: '#f3c4c0' },
};

export function Button({ variant = 'primary', full = false, style, ...rest }: Props) {
  const colors = COLORS[variant];
  return (
    <button
      {...rest}
      style={{
        minHeight: 'var(--tap)',
        width: full ? '100%' : undefined,
        padding: '0.6rem 1rem',
        borderRadius: 'var(--radius-sm)',
        border: `1px solid ${colors.border}`,
        background: colors.bg,
        color: colors.fg,
        fontSize: '1rem',
        fontWeight: 600,
        cursor: rest.disabled ? 'not-allowed' : 'pointer',
        opacity: rest.disabled ? 0.6 : 1,
        ...style,
      }}
    />
  );
}
